import { render, staticRenderFns } from "./CortexDarkIcon.vue?vue&type=template&id=1231fd6f&"
import script from "./CortexDarkIcon.vue?vue&type=script&lang=ts&"
export * from "./CortexDarkIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports